import React from 'react';

interface Reminder { id: string; title: string; due_at: string; }
interface Payload { items?: Reminder[]; }

function fmt(iso: string): string {
  try { return new Date(iso).toLocaleString('ru', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }); }
  catch { return iso; }
}

export default function UpcomingReminders({ data }: { data: unknown }) {
  const items = ((data ?? {}) as Payload).items ?? [];
  const wrapSt:  React.CSSProperties = { height: '100%', display: 'flex', flexDirection: 'column' };
  const labelSt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', marginBottom: 8, margin: 0 };
  const listSt:  React.CSSProperties = { flex: 1, overflowY: 'auto', listStyle: 'none', margin: 0, padding: 0, marginTop: 8 };
  const itemSt:  React.CSSProperties = { marginBottom: 8 };
  const titleSt: React.CSSProperties = { fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', margin: 0 };
  const dateSt:  React.CSSProperties = { fontSize: 11, color: 'var(--tg-theme-hint-color)', margin: '2px 0 0' };
  const emptySt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', flex: 1, display: 'flex', alignItems: 'center' };
  return (
    <div style={wrapSt}>
      <p style={labelSt}>Напоминания</p>
      {items.length === 0 ? (
        <p style={emptySt}>Нет запланированных</p>
      ) : (
        <ul style={listSt}>
          {items.slice(0, 5).map((r) => (
            <li key={r.id} style={itemSt}>
              <p style={titleSt}>{r.title}</p>
              <p style={dateSt}>{fmt(r.due_at)}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
